import { ProductState } from "./product-state.model";

export class PricingQuotaConfiguration {
  private pricingQuotaConfigurationKey: string;
  private quota: number;
  private state: ProductState;
  private freeCommercialArea: boolean;
  private cluster: string;

  public getPricingQuotaConfigurationKey(): string {
    return this.pricingQuotaConfigurationKey;
  }

  public setPricingQuotaConfigurationKey(pricingQuotaConfigurationKey: string): void {
    this.pricingQuotaConfigurationKey = pricingQuotaConfigurationKey;
  }

  public getQuota(): number {
    return this.quota;
  }

  public setQuota(quota: number): void {
    this.quota = quota;
  }

  public getState(): ProductState {
    return this.state;
  }

  public setState(state: ProductState): void {
    this.state = state;
  }

  public isFreeCommercialArea(): boolean {
    return this.freeCommercialArea;
  }

  public setFreeCommercialArea(freeCommercialArea: boolean): void {
    this.freeCommercialArea = freeCommercialArea;
  }

  public getCluster(): string {
    return this.cluster;
  }

  public setCluster(cluster: string): void {
    this.cluster = cluster;
  }
}
